import {
  nextFormalNewQuoteId,
  projectBlankWorkspaceState,
} from '../../../quote-integration/quoteLegacyProjection';
import { isCasePreviewEnabled } from './caseFeature';
import type { CpqState } from './types';

export function caseDraftSnapshots(state: CpqState): CpqState['quotes'] {
  return Object.fromEntries(
    Object.entries(state.quotes).filter(
      ([, quote]) => quote?.caseRehearsalSnapshot,
    ),
  );
}

export function projectCasePreview(
  state: CpqState,
  fallback: CpqState,
  storedCases: CpqState['quotes'] = {},
  placeholderIds = new Set<string>(),
): CpqState {
  if (isCasePreviewEnabled()) return state;
  const hiddenIds = new Set(
    Object.keys({ ...storedCases, ...caseDraftSnapshots(state) }),
  );
  if (!hiddenIds.size) return state;
  let quotes = Object.fromEntries(
    Object.entries(state.quotes).filter(([id]) => !hiddenIds.has(id)),
  );
  if (!Object.keys(quotes).length)
    quotes = Object.fromEntries(
      Object.entries(fallback.quotes).filter(
        ([id, quote]) => !hiddenIds.has(id) && !quote.caseRehearsalSnapshot,
      ),
    );
  if (!Object.keys(quotes).length) {
    const id = nextFormalNewQuoteId({ ...state, openQuoteIds: [...hiddenIds] });
    const { customers, devices, packages, plans } = state.catalog;
    const blank = projectBlankWorkspaceState(
      {
        ...state,
        quotes: { ...storedCases, ...state.quotes },
        openQuoteIds: [],
      },
      customers,
      devices,
      packages,
      plans,
      false,
      id,
    );
    placeholderIds.add(id);
    return {
      ...blank,
      activeQuoteVersionId: undefined,
      quotes: {
        [id]: { ...blank.quotes[id], caseRehearsalSnapshot: undefined },
      },
    };
  }
  const openQuoteIds = state.openQuoteIds.filter((id) => !hiddenIds.has(id));
  const hiddenActive = hiddenIds.has(state.activeQuoteId);
  return {
    ...state,
    quotes,
    openQuoteIds,
    ...(hiddenActive
      ? {
          activeQuoteId:
            openQuoteIds.at(-1) ?? (Object.keys(quotes)[0] as string),
          activeQuoteVersionId: undefined,
        }
      : {}),
  };
}
